import Vue from 'vue';

export const permPlacementsListingService = {
  async retrievePermPlacements(filters, sortOrder, paginationParameters) {
    return Vue.axios
      .get('/perm-placements', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters,
          ...sortOrder,
          ...paginationParameters
        }
      })
      .then(response => response.data);
  },

  async retrieveFilteredRecordCount(filters) {
    return Vue.axios
      .get('/perm-placements/count-records', {
        params: {
          ...filters.dateRangeFilters,
          ...filters.statusFilters
        }
      })
      .then(response => response.data);
  },

  async doPermPlacementAction(permPlacements, action, comment) {
    return Vue.axios
      .post('/perm-placements/bulk-update', {
        bulkAction: { action, comment },
        referenceNumbers: permPlacements
      })
      .then(response => response.data);
  }
};
